module.exports = __webpack_public_path__ + "static/media/drag-icon.3b0cd5f6.svg";